import React, { useState } from "react";
import GetWindowSize from "../../../hooks/general/GetWindowSize"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faX } from "@fortawesome/free-solid-svg-icons";
import axios from "axios";
import GetCSFR from "../../../hooks/userAuthentication/GetCSFR";
import LoadingAnimation from "../LoadingAnimation";
import CoachPreview from "./CoachPreview";

interface Props {
    displayForm:(value:boolean) => void
    coachList: CoachProfile[] | undefined;
}

interface CoachProfile {
    id: string;
    fullname: string;
    specialization: string;
    location: string;
    rating: number;
}


export default function RemoveCoach({displayForm, coachList}:Props){
    const csrfToken = GetCSFR({ name: "csrftoken" })
    const windowSize = GetWindowSize()
    const [insideForm, setInsideForm] = useState<boolean>(false)
    const [submitting, setSubmitting] = useState<boolean>(false)

    // Close the form if user clicks outside of it
    function handleExit(value:boolean){
        if(!insideForm){
            displayForm(value)
        }
    }

    function removeCoachFromClub(coachId: string) {
        setSubmitting(true)

        axios.post(`${process.env.REACT_APP_SKILLJA_URL}/auth/club/remove_coach/`, { coachId: coachId }, {
                headers: {
                    "X-CSRFToken": csrfToken,
                    "Content-Type": "application/json",
                },
                withCredentials: true,
            }
            )
            .then(() => {displayForm(false)})
            .catch(() => { alert("Unable to remove coach. Please try again.")})
            .finally(() => {
                setSubmitting(false)
                window.location.reload()
            })
    }

    return (
        <div className="pop-up-background" 
            onClick={windowSize.width >=1024 ? 
                ()=>handleExit(false) 
            : 
                undefined
            }
        > 
            <div 
                className="pop-up-container h-3/5"
                onMouseEnter={()=>setInsideForm(true)} 
                onMouseLeave={()=>setInsideForm(false)}
            >
                <div className="grid grid-cols-3 grid-rows-1 p-5 px-7 lg:px-10 bg-main-white rounded-t-xl">
                    <FontAwesomeIcon 
                        icon={faX}
                        className="text-main-green-900 hover:text-main-green-500 mr-auto my-auto cursor-pointer"
                        onClick={()=>handleExit(false)}
                        onMouseEnter={()=>setInsideForm(false)}
                    />
                    <p className="text-lg mx-auto underline">Delete Coach From Club</p>
                    <p></p>
                </div>
                {submitting ?
                    <div className="mt-10">
                        <LoadingAnimation />
                    </div>
                :
                    <div className="mx-auto px-4 overflow-scroll h-80">
                        {coachList && coachList.length > 0 ?
                            coachList.map((coach,index)=>{
                                return (
                                    <div className="flex mt-4 border-b">
                                        <div className="w-4/6 mr-3 pt-2">
                                            <CoachPreview 
                                                key={index} 
                                                id={coach.id} 
                                                fullname={coach.fullname} 
                                                specialization={coach.specialization} 
                                                location={coach.location} 
                                                rating={coach.rating}
                                                hideReviews={true}
                                            />
                                        </div>
                                        <button 
                                            className="form-btn bg-red-500 hover:bg-red-700 sm:text-xs text-sm px-3 py-1.5 ml-auto my-auto"
                                            onClick={()=>{
                                                removeCoachFromClub(coach.id)
                                            }}
                                        >
                                            Delete
                                        </button>
                                    </div>
                                )
                            })
                        :
                            <p className="mx-auto mt-6">
                                No coaches available.
                            </p>
                        }
                    </div>
                }
            </div>
        </div>
    )
}